import React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { unregister } from './registerServiceWorker'

createRoot(document.getElementById('root')).render(<App />)

unregister()
